import React from 'react';
import { Dialog, DialogActions, DialogContent } from '@mui/material';
import PrimaryButton from '../../common/components/PrimaryButton';

type Props = {
    isOpen: boolean;
    handleClose: () => void;
};

const WELCOME_ITEMS = [
    'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
    'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    'Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.',
    'Duis aute irure dolor in reprehenderit in voluptate velit esse.'
];

export default function AthleteWelcomeDialog({ isOpen, handleClose }: Props) {
    return (
        <Dialog
            data-testid="dialog"
            open={isOpen}
            onClose={handleClose}
            aria-labelledby="athlete-welcome-title"
            fullWidth
            maxWidth="sm"
        >
            <DialogContent>
                <div className="title-container">
                    <div id="athlete-welcome-title" className="title">
                        Welcome to TrainHeroic!
                    </div>
                </div>
                <ul>
                    {WELCOME_ITEMS.map(item => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
                <p>
                    <strong>Download the TrainHeroic mobile app</strong> to log workouts, track your progress and get
                    the best athlete experience.
                </p>
            </DialogContent>
            <DialogActions>
                <div className="action-buttons-container" style={{ width: '100%' }}>
                    <PrimaryButton onClick={handleClose}>Get Started</PrimaryButton>
                </div>
            </DialogActions>
        </Dialog>
    );
}
